import React from "react";
import platform from "Pub/js/platform";
import { langCheck } from "Pub/js/utils";
import "./index.less";
const { toast, clearToast, base } = platform;
const { NCTooltip } = base;
/**
 * @param {String} status 状态标识
 * @param {String} msg 提示信息
 * @param {Number} duration 显示时间 单位秒
 * @param {String} url 跳转url （ 预警需要 ）
 * @param {Number} day 授权剩余天数 （ 过期预警需要 ）
 */
const Notice = ({
    status,
    msg = langCheck("0000PUB-000020"),
    duration = 6,
    url,
    day,
    cb,
    ...toastApi
}) => {
    // 预警、过期警告
    if (["earlyWarning", "overdueWarning"].includes(status)) {
        const toastMark = `open${Date.now()}`;
        const toastObj = {
            color: 'warning',
            global: true, // toast不会消失，duration就不用传了
            // duration: 9999, // 组件暂时不支持常显，席泉泉建议先设置时间为9999
            mark: toastMark,
            ...toastApi
        }
        switch (status) {
            // 预警
            case "earlyWarning":
                toast({
                    title: langCheck("0000PUB-000025"),
                    content: `\n${msg}`, // \n为了换行
                    groupOperation: true, // 必须有这个 customBtnBeforeClose 才能出现
                    customBtnBeforeClose: <NCTooltip
                        overlayClassName="view-tip"
                        overlay={langCheck("0000PUB-000026")}
                        zIndex={99999}
                    >
                        <a
                            className="iconfont icon-lijichakan"
                            href={url}
                            target="_blank"
                            rel="noreferrer" // 解决https不能预览问题
                            onClick={() => clearToast(toastMark)}
                        />
                    </NCTooltip>,
                    usePunctuation: false, // title已经包含感叹号了，这里不需要
                    className: 'toast-early-warning',
                    ...toastObj
                })
                break;
            // 过期警告
            case "overdueWarning":
                toast({
                    content: `${langCheck("0000PUB-000028")} ${day} ${langCheck("0000PUB-000029")}`, /* 国际化处理： 您的授权将在,天后到期，请注意及时续费*/
                    ...toastObj
                })
                break;
            default:
                break;
        }
    } else {
        //消息提示用1903版toast
        if (["error", "typeError"].includes(status)) {
            status = "danger";
        } else if (status === "simpleSuccess") {
            status = "success";
        } else if (status === "info") {
            // 消息提示
            toast({
                color: "info",
                content: msg,
                light: true,
                lightClick: cb
            });
            return;
        }
        toast({ color: status, content: msg, ...toastApi });
    }
};

export default Notice;
